/* Street Garms Search Governance v6.1 - strict title-first storefront search + native facet stability */
(function () {
  'use strict';

  function normaliseKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getConfig() {
    var node = document.getElementById('sg-search-governance-config');
    if (!node) return { routes: {}, brandAliases: {} };
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('SG-050 search config could not be parsed', error);
      return { routes: {}, brandAliases: {} };
    }
  }

  var config = getConfig();

  function isSearchPage() {
    return window.location.pathname.replace(/\/+$/, '') === '/search';
  }

  function getSearchInput(form) {
    return form && form.querySelector('input[name="q"]');
  }

  function isFilterSettingGroupGid(value) {
    return /^gid:\/\/shopify\/FilterSettingGroup\/\d+$/i.test(String(value || '').trim());
  }

  function cleanSearchQuery(value) {
    return String(value || '')
      .replace(/gid:\/\/shopify\/FilterSettingGroup\/\d+/ig, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }


  /*
    Shopify's normal storefront search considers title, product type, variant
    title and vendor. Street Garms product titles are already highly structured,
    so free-text search is intentionally made title-first here. Known brands are
    matched against vendor, while every remaining shopper term must exist in the
    product title. This prevents searches such as "Stone Island jumper" from
    returning unrelated Stone Island gilets simply because other indexed fields
    happen to match.
  */
  function displayQueryFromEngine(value) {
    return cleanSearchQuery(value)
      .replace(/\bvendor:"([^"]+)"/gi, '$1')
      .replace(/\bvendor:([^\s]+)/gi, '$1')
      .replace(/\btitle:"([^"]+)"/gi, '$1')
      .replace(/\btitle:([^\s]+)/gi, '$1')
      .replace(/\bAND\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeSearchValue(value) {
    return String(value || '').replace(/([\\:()])/g, '\\$1');
  }

  function quoteSearchPhrase(value) {
    return '"' + escapeSearchValue(value).replace(/"/g, '\\"') + '"';
  }

  function hasExplicitSearchField(value) {
    return /(?:^|\s)(?:title|vendor|product_type|tag|variants\.(?:title|sku|barcode)):/i.test(String(value || ''));
  }

  function buildTitleFocusedQuery(value) {
    var human = displayQueryFromEngine(value);
    if (!human) return '';

    /* Respect an intentionally fielded query rather than double-wrapping it. */
    if (hasExplicitSearchField(value)) return cleanSearchQuery(value);

    var brands = [
      { re: /\b(?:c\.?\s*p\.?|cp)\s*company\b|\bcpcompany\b/i, vendor: 'C.P. Company' },
      { re: /\bstone\s*island\b|\bstoneisland\b/i, vendor: 'Stone Island' },
      { re: /\barc(?:['’]|\s)?teryx\b|\barcteryx\b/i, vendor: "Arc'teryx" },
      { re: /\b(?:the\s+)?north\s*face\b|\bnorthface\b|\btnf\b/i, vendor: 'The North Face' },
      { re: /\bpalm\s*angels\b/i, vendor: 'Palm Angels' },
      { re: /\bcanada\s*goose\b/i, vendor: 'Canada Goose' },
      { re: /\bma\.?\s*strum\b|\bmastrum\b/i, vendor: 'MA.STRUM' },
      { re: /\bmoncler\b/i, vendor: 'Moncler' },
      { re: /\bsupreme\b/i, vendor: 'Supreme' },
      { re: /\bpalace\b/i, vendor: 'Palace' }
    ];

    var clauses = [];
    var rest = human;
    for (var i = 0; i < brands.length; i += 1) {
      if (brands[i].re.test(rest)) {
        clauses.push('vendor:' + quoteSearchPhrase(brands[i].vendor));
        rest = rest.replace(brands[i].re, ' ');
        break;
      }
    }

    /* Common shopper spelling -> the way product titles are normally written. */
    rest = rest
      .replace(/\bt[\s-]?shirts?\b/ig, 'T-Shirt')
      .replace(/\btee(?:\s*shirts?)?\b/ig, 'T-Shirt')
      .replace(/\s+/g, ' ')
      .trim();

    var terms = rest.match(/"[^"]+"|[^\s]+/g) || [];
    var stopWords = { 'a': true, 'an': true, 'and': true, 'for': true, 'of': true };
    terms.forEach(function (term) {
      var cleaned = String(term || '').replace(/^"|"$/g, '').trim();
      if (!cleaned || stopWords[cleaned.toLowerCase()]) return;
      if (/\s/.test(cleaned)) clauses.push('title:' + quoteSearchPhrase(cleaned));
      else clauses.push('title:' + escapeSearchValue(cleaned));
    });

    return clauses.join(' ').replace(/\s+/g, ' ').trim();
  }

  function getFilterKeyParts(toggle) {
    var key = toggle && toggle.getAttribute ? (toggle.getAttribute('data-sg-filter-key') || '') : '';
    var splitAt = key.indexOf('::');
    if (splitAt < 1) return null;
    return {
      param: key.slice(0, splitAt),
      value: key.slice(splitAt + 2)
    };
  }

  function canonicalSizeLabel(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/[_/]+/g, ' ')
      .replace(/[-]+/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';
    if (/\b(?:3xl|xxxl|xxx large|xxxlarge)\b/.test(text)) return 'xxxl';
    if (/\b(?:2xl|xxl|xx large|xxlarge)\b/.test(text)) return 'xxl';
    if (/\b(?:1xl|xl|x large|xlarge|extra large)\b/.test(text)) return 'xl';
    if (/\b(?:xs|x small|xsmall|extra small)\b/.test(text)) return 'xs';
    if (/\bmedium\b|\bmed\b/.test(text)) return 'medium';
    if (/\bsmall\b/.test(text)) return 'small';
    if (/\blarge\b/.test(text)) return 'large';
    return '';
  }

  function extractRequestedSize(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/[_/]+/g, ' ')
      .replace(/[-]+/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';

    if (/\b(?:3xl|xxxl|xxx large|xxxlarge)\b/.test(text)) return 'XXX-Large';
    if (/\b(?:2xl|xxl|xx large|xxlarge)\b/.test(text)) return 'XX-Large';
    if (/\b(?:1xl|xl|x large|xlarge|extra large)\b/.test(text)) return 'X-Large';
    if (/\b(?:xs|x small|xsmall|extra small)\b/.test(text)) return 'X-Small';

    var labelled = text.match(/\bsize\s+(small|medium|large)\b/);
    if (labelled) {
      return labelled[1] === 'small' ? 'Small' : labelled[1] === 'medium' ? 'Medium' : 'Large';
    }

    var trailing = text.match(/\b(small|medium|large)\s*$/);
    if (trailing) {
      return trailing[1] === 'small' ? 'Small' : trailing[1] === 'medium' ? 'Medium' : 'Large';
    }

    return '';
  }

  function getSizeFilterMapping(requestedSize) {
    var map = document.querySelector('[data-sg050-size-filter-map]');
    if (!map) return null;

    var param = map.getAttribute('data-sg050-size-filter-param') || 'filter.p.m.custom.size';
    var requestedCanonical = canonicalSizeLabel(requestedSize);
    if (!requestedCanonical) return null;

    var values = map.querySelectorAll('[data-sg050-size-filter-label][data-sg050-size-filter-value]');
    for (var i = 0; i < values.length; i += 1) {
      var label = values[i].getAttribute('data-sg050-size-filter-label') || '';
      if (canonicalSizeLabel(label) === requestedCanonical) {
        return {
          param: param,
          value: values[i].getAttribute('data-sg050-size-filter-value') || '',
          label: label
        };
      }
    }
    return null;
  }

  function stripRequestedSizeTerm(query, requestedSize) {
    var value = String(query || '').trim();
    var canonical = canonicalSizeLabel(requestedSize);
    var patterns = {
      xxxl: /(?:\s+|^)(?:3xl|xxxl|xxx[ -]?large)\s*$/i,
      xxl: /(?:\s+|^)(?:2xl|xxl|xx[ -]?large)\s*$/i,
      xl: /(?:\s+|^)(?:1xl|xl|x[ -]?large|extra[ -]?large)\s*$/i,
      xs: /(?:\s+|^)(?:xs|x[ -]?small|extra[ -]?small)\s*$/i,
      medium: /(?:\s+|^)(?:size\s+)?medium\s*$/i,
      small: /(?:\s+|^)(?:size\s+)?small\s*$/i,
      large: /(?:\s+|^)(?:size\s+)?large\s*$/i
    };
    var pattern = patterns[canonical];
    if (pattern) value = value.replace(pattern, ' ').replace(/\s+/g, ' ').trim();
    return value || String(query || '').trim();
  }

  function ensureSearchDefaults(params) {
    var changed = false;
    var keysToDelete = [];

    params.forEach(function (_value, key) {
      if (key === 'options' || /^options\s*\{/.test(key)) keysToDelete.push(key);
    });

    keysToDelete.forEach(function (key) {
      params.delete(key);
      changed = true;
    });

    if (params.get('type') !== 'product') {
      params.set('type', 'product');
      changed = true;
    }
    if (params.get('options[unavailable_products]') !== 'hide') {
      params.set('options[unavailable_products]', 'hide');
      changed = true;
    }
    if (params.get('options[prefix]') !== 'last') {
      params.set('options[prefix]', 'last');
      changed = true;
    }

    return changed;
  }

  function recoverLegacyGroupedGids(params) {
    if (!params) return false;

    var rawQuery = params.get('q') || '';
    var gids = rawQuery.match(/gid:\/\/shopify\/FilterSettingGroup\/\d+/ig) || [];
    if (!gids.length) return false;

    var changed = false;
    var cleanQuery = cleanSearchQuery(rawQuery);
    if (cleanQuery) params.set('q', cleanQuery);
    else params.delete('q');
    changed = true;

    /*
      v5.4/v5.5 could accidentally place Search & Discovery group IDs in q.
      If the current facet DOM still exposes that same group ID, restore it to
      its real Shopify filter parameter. Never translate a group ID into text.
    */
    var toggles = document.querySelectorAll('#t4s-filter-hidden [data-sg-filter-key]');
    gids.forEach(function (gid) {
      for (var i = 0; i < toggles.length; i += 1) {
        var parts = getFilterKeyParts(toggles[i]);
        if (!parts || parts.value !== gid || !parts.param || parts.param === 'q') continue;
        if (params.getAll(parts.param).indexOf(gid) === -1) {
          params.append(parts.param, gid);
          changed = true;
        }
        break;
      }
    });

    return changed;
  }

  function governedSearchSubmit(event) {
    if (event.defaultPrevented) return;

    var form = event.target;
    if (!form || !form.matches('form[role="search"], form[data-frm-search], .t4s-search-form')) return;

    /*
      Predictive search owns an explicitly highlighted keyboard selection.
      Let that component navigate to the selected product/category instead of
      rebuilding the typed phrase into a new /search URL.
    */
    var predictive = form.closest('[data-predictive-search]');
    var selectedLink = predictive && predictive.querySelector('[aria-selected="true"] a[href]');
    if (selectedLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(selectedLink.href);
      return;
    }

    var input = getSearchInput(form);
    if (!input) return;

    var raw = cleanSearchQuery(input.value);
    if (!raw) return;
    input.value = raw;

    var key = normaliseKey(raw);
    var route = config.routes && config.routes[key];

    if (route) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(route);
      return;
    }

    if (config.brandAliases && config.brandAliases[key]) {
      input.value = config.brandAliases[key];
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var params = new URLSearchParams();
    var requestedSize = extractRequestedSize(input.value.trim());
    var humanForSearch = requestedSize ? stripRequestedSizeTerm(input.value.trim(), requestedSize) : input.value.trim();
    var focusedQuery = buildTitleFocusedQuery(humanForSearch);
    params.set('q', focusedQuery || humanForSearch);
    if (requestedSize) params.set('sg_size', requestedSize);
    params.set('type', 'product');
    params.set('options[unavailable_products]', 'hide');
    params.set('options[prefix]', 'last');

    var productType = form.querySelector('select[name="product_type"], select[data-name="product_type"]');
    if (productType && productType.value && productType.value !== '*') {
      params.set('q', 'product_type:' + quoteSearchPhrase(productType.value) + ' AND ' + (focusedQuery || input.value.trim()));
    }

    var action = form.getAttribute('action') || '/search';
    window.location.assign(action + '?' + params.toString());
  }

  function canonicaliseCurrentSearchURL() {
    if (!isSearchPage()) return;

    var params = new URLSearchParams(window.location.search);
    var changed = recoverLegacyGroupedGids(params);
    if (ensureSearchDefaults(params)) changed = true;

    var currentQuery = params.get('q') || '';
    var cleanQuery = cleanSearchQuery(currentQuery);
    var displayQuery = displayQueryFromEngine(cleanQuery);

    if (cleanQuery !== currentQuery) {
      if (cleanQuery) params.set('q', cleanQuery);
      else params.delete('q');
      changed = true;
    }

    /*
      Important: Brand and Category/Product Type filters are deliberately left
      as Shopify filter parameters. Search & Discovery grouped values are opaque
      FilterSettingGroup GIDs, and Shopify's own value.url_to_add/url_to_remove
      is the authoritative URL. Previous versions converted these GIDs into q,
      which caused the broken “PALACE GID://...” / zero-result behaviour.
    */

    var stagedSize = params.get('sg_size') || '';
    var requestedSize = stagedSize || extractRequestedSize(displayQuery);
    if (requestedSize) {
      var mapping = getSizeFilterMapping(requestedSize);
      if (mapping && mapping.param && mapping.value && params.get(mapping.param) !== mapping.value) {
        var withoutSize = stagedSize ? displayQuery : stripRequestedSizeTerm(displayQuery, requestedSize);
        var sizeFocusedQuery = buildTitleFocusedQuery(withoutSize);
        if (sizeFocusedQuery) params.set('q', sizeFocusedQuery);
        else params.delete('q');
        params.delete(mapping.param);
        params.append(mapping.param, mapping.value);
        params.delete('sg_size');
        changed = true;
      } else if (stagedSize) {
        /* Never leave a private staging parameter in a customer-facing URL. */
        params.delete('sg_size');
        changed = true;
      }
    } else if (cleanQuery && !hasExplicitSearchField(cleanQuery)) {
      var focusedCurrentQuery = buildTitleFocusedQuery(displayQuery);
      if (focusedCurrentQuery && focusedCurrentQuery !== cleanQuery) {
        params.set('q', focusedCurrentQuery);
        changed = true;
      }
    }

    if (changed && params.has('page')) params.delete('page');

    if (changed) {
      window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
    }
  }

  function buildStableFacetURL(toggle) {
    var href = toggle && toggle.getAttribute ? toggle.getAttribute('href') : '';
    if (!href) return null;

    var url = new URL(href, window.location.origin);
    recoverLegacyGroupedGids(url.searchParams);
    ensureSearchDefaults(url.searchParams);

    var query = cleanSearchQuery(url.searchParams.get('q') || '');
    if (query) url.searchParams.set('q', query);
    else url.searchParams.delete('q');

    url.searchParams.delete('page');

    /*
      Brand and Categories are presented as radio-style controls in this theme.
      Keep that single-choice behaviour, but keep the actual Shopify group value
      in its native filter parameter. Never use the opaque value as search text.
    */
    if (toggle.getAttribute('data-sg-single-select') === 'true') {
      var parts = getFilterKeyParts(toggle);
      if (parts && parts.param && parts.value) {
        var isActive = toggle.getAttribute('aria-checked') === 'true' ||
          (toggle.closest('li') && toggle.closest('li').classList.contains('is--selected'));

        url.searchParams.delete(parts.param);
        if (!isActive) url.searchParams.append(parts.param, parts.value);
      }
    }

    return url;
  }

  function governSearchFacetClick(event) {
    if (!isSearchPage()) return;

    var toggle = event.target && event.target.closest
      ? event.target.closest('#t4s-filter-hidden [data-sg-filter-toggle]')
      : null;
    if (!toggle) return;

    if (toggle.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    try {
      var url = buildStableFacetURL(toggle);
      if (!url) return;

      /*
        Search facets use a full navigation intentionally. Kalles' AJAX layer is
        left untouched on collections, while Search always follows Shopify's
        server-generated facet URL. This removes the race between custom query
        governance and Kalles AJAX that made grouped filters intermittent.
      */
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.assign(url.pathname + '?' + url.searchParams.toString() + url.hash);
    } catch (_error) {
      /* Fall back to Shopify's native href if URL normalisation ever fails. */
    }
  }

  function governSearchPaginationClick(event) {
    if (!isSearchPage()) return;

    var link = event.target && event.target.closest
      ? event.target.closest('.t4s-main-collection-search [data-ntjax-wrap] a[href], .t4s-main-collection-search [data-ntjax-link][href], .t4s-main-collection-search .t4s-pagination-wrapper a[href]')
      : null;
    if (!link) return;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      recoverLegacyGroupedGids(url.searchParams);
      ensureSearchDefaults(url.searchParams);

      var query = cleanSearchQuery(url.searchParams.get('q') || '');
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');

      /*
        Kalles normally intercepts these links, AJAX-replaces the results container
        and runs its own animated scrollToTop(). On Search that creates a second
        navigation/render path alongside SG governance. Use one deterministic server
        navigation instead; Collections retain Kalles AJAX/infinite scrolling.
      */
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.assign(url.pathname + '?' + url.searchParams.toString() + url.hash);
    } catch (_error) {
      /* Leave the native href available as the fallback. */
    }
  }

  function governSearchFilterAction(event) {
    if (!isSearchPage()) return;

    var link = event.target && event.target.closest
      ? event.target.closest('.t4s-active-filters__remove-filter, [data-sg-clear-all]')
      : null;
    if (!link || !link.getAttribute('href')) return;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      recoverLegacyGroupedGids(url.searchParams);
      ensureSearchDefaults(url.searchParams);
      var query = cleanSearchQuery(url.searchParams.get('q') || '');
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      url.searchParams.delete('page');

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.assign(url.pathname + '?' + url.searchParams.toString() + url.hash);
    } catch (_error) {
      /* Native link remains the fallback. */
    }
  }


  function numberFromPriceInput(value) {
    var number = parseFloat(String(value || '').replace(/,/g, ''));
    return Number.isFinite(number) ? number : null;
  }

  function governSearchPriceFilter(event) {
    if (!isSearchPage()) return;

    var button = event.target && event.target.closest
      ? event.target.closest('#t4s-filter-hidden .t4s-price_slider_btn')
      : null;
    if (!button) return;

    var amount = button.closest('.t4s-price_slider_amount');
    if (!amount) return;

    var minParam = amount.getAttribute('data-minstr') || '';
    var maxParam = amount.getAttribute('data-maxstr') || '';
    var minInput = amount.querySelector('.t4s-min_price');
    var maxInput = amount.querySelector('.t4s-max_price');
    if (!minParam || !maxParam || !minInput || !maxInput) return;

    var currentMin = numberFromPriceInput(minInput.value);
    var currentMax = numberFromPriceInput(maxInput.value);
    var absoluteMin = numberFromPriceInput(minInput.getAttribute('data-min'));
    var absoluteMax = numberFromPriceInput(maxInput.getAttribute('data-max'));
    if (currentMin === null || currentMax === null) return;

    try {
      var url = new URL(window.location.href);
      recoverLegacyGroupedGids(url.searchParams);
      ensureSearchDefaults(url.searchParams);

      var query = cleanSearchQuery(url.searchParams.get('q') || '');
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');

      if (absoluteMin !== null && currentMin <= absoluteMin) url.searchParams.delete(minParam);
      else url.searchParams.set(minParam, String(currentMin));

      if (absoluteMax !== null && currentMax >= absoluteMax) url.searchParams.delete(maxParam);
      else url.searchParams.set(maxParam, String(currentMax));

      url.searchParams.delete('page');

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.assign(url.pathname + '?' + url.searchParams.toString() + url.hash);
    } catch (_error) {
      /* Kalles' native price handler remains the last-resort fallback. */
    }
  }

  document.addEventListener('click', governSearchFacetClick, true);
  document.addEventListener('click', governSearchPaginationClick, true);
  document.addEventListener('click', governSearchFilterAction, true);
  document.addEventListener('click', governSearchPriceFilter, true);
  /* Bubble phase lets predictive-search's form-level keyboard selection run first. */
  document.addEventListener('submit', governedSearchSubmit, false);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', canonicaliseCurrentSearchURL, { once: true });
  } else {
    canonicaliseCurrentSearchURL();
  }

  document.documentElement.setAttribute('data-sg050-search', 'ready');
})();

/* SG-050.5: explicit-size ranking fallback on the full search results page. */
(function () {
  'use strict';

  function isSearchPageLocal() {
    return window.location.pathname.replace(/\/+$/, '') === '/search';
  }

  function canonicalSize(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/[_/]+/g, ' ')
      .replace(/[-]+/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';
    if (/\b(?:3xl|xxxl|xxx large|xxxlarge)\b/.test(text)) return 'xxxl';
    if (/\b(?:2xl|xxl|xx large|xxlarge)\b/.test(text)) return 'xxl';
    if (/\b(?:1xl|xl|x large|xlarge|extra large)\b/.test(text)) return 'xl';
    if (/\b(?:xs|x small|xsmall|extra small)\b/.test(text)) return 'xs';
    if (/\bmedium\b|\bmed\b/.test(text)) return 'medium';
    if (/\bsmall\b/.test(text)) return 'small';
    if (/\blarge\b/.test(text)) return 'large';
    return '';
  }

  function requestedSizeFromQuery(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/’/g, "'")
      .replace(/[_/]+/g, ' ')
      .replace(/[-]+/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text) return '';
    if (/\b(?:3xl|xxxl|xxx large|xxxlarge)\b/.test(text)) return 'xxxl';
    if (/\b(?:2xl|xxl|xx large|xxlarge)\b/.test(text)) return 'xxl';
    if (/\b(?:1xl|xl|x large|xlarge|extra large)\b/.test(text)) return 'xl';
    if (/\b(?:xs|x small|xsmall|extra small)\b/.test(text)) return 'xs';

    var labelled = text.match(/\bsize\s+(small|medium|large)\b/);
    if (labelled) return canonicalSize(labelled[1]);
    var trailing = text.match(/\b(small|medium|large)\s*$/);
    if (trailing) return canonicalSize(trailing[1]);
    return '';
  }

  function sizeDistance(requested, productSize) {
    var order = ['xs', 'small', 'medium', 'large', 'xl', 'xxl', 'xxxl'];
    var a = order.indexOf(requested);
    var b = order.indexOf(productSize);
    if (a < 0 || b < 0) return 99;
    return Math.abs(a - b);
  }

  function productCardSize(card) {
    if (!card) return '';
    var sizeNode = card.querySelector('.sg043-card-meta__variant--size-condition > span:first-child');
    if (!sizeNode) sizeNode = card.querySelector('.sg043-card-meta__variant--size-colour > span:first-child');
    return canonicalSize(sizeNode ? sizeNode.textContent : '');
  }

  function currentSortIsRelevance() {
    var params = new URLSearchParams(window.location.search);
    var sort = String(params.get('sort_by') || '').toLowerCase();
    return !sort || sort === 'relevance' || sort === 'manual';
  }

  function hasNativeSizeFilter(params) {
    var found = false;
    params.forEach(function (_value, key) {
      if (key === 'filter.p.m.custom.size' || /size/i.test(key) && /^filter\./.test(key)) found = true;
    });
    return found;
  }

  function applyFullSearchRanking() {
    if (!isSearchPageLocal() || !currentSortIsRelevance()) return;

    var params = new URLSearchParams(window.location.search);
    var requested = requestedSizeFromQuery(params.get('q') || '');
    if (!requested || hasNativeSizeFilter(params)) return;

    var grid = document.querySelector('.t4s-main-collection-search [data-contentlm-replace].t4s-products');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.children).filter(function (node) {
      return node && node.matches && node.matches('.t4s-product');
    });
    if (cards.length < 2) return;

    var ranked = cards.map(function (card, index) {
      var size = productCardSize(card);
      return {
        card: card,
        index: index,
        size: size,
        known: !!size,
        distance: size ? sizeDistance(requested, size) : 99
      };
    }).sort(function (a, b) {
      if (a.known !== b.known) return a.known ? -1 : 1;
      if (a.distance !== b.distance) return a.distance - b.distance;
      return a.index - b.index;
    });

    var changed = ranked.some(function (entry, index) {
      return entry.card !== cards[index];
    });
    if (!changed) return;

    ranked.forEach(function (entry) {
      grid.appendChild(entry.card);
    });
    grid.setAttribute('data-sg050-size-ranked', requested);
  }

  var scheduled = false;
  function scheduleRanking() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyFullSearchRanking();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRanking, { once: true });
  } else {
    scheduleRanking();
  }

  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      var target = mutation.target;
      return target && target.closest && target.closest('.t4s-main-collection-search');
    });
    if (relevant) scheduleRanking();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
